<template>
  <el-container class="layout-container">
    <el-header ref="topheader" class="header-container">
    </el-header>
     <el-main class="main-container">
         <router-view/>
    </el-main>
     </el-container>
</template>
<script>
export default {
  components: { }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
$headerHeight:55px;
.layout-container{
  // height: 100%;
  background-color:#f9f9f9;
  .header-container{
    padding: 0;
    height: $headerHeight !important;
  }
  .main-container{
    // padding-top: 5px;
    padding: 0px 10% 0px 10%;
    margin-left: 0px !important;
    height: calc(100% - #{$headerHeight});
    .main-container{
      padding: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/Blank.vue